import { useState } from 'react'
import { useToast } from '@ims/ui'
import { errorMessage } from '../hooks.ts'
import { useRepo, useWorkspace } from '../workspace.tsx'

// Shared by the restaurant screens (tables, orders, deliveries).

/** Runs a write, showing its error as a toast. */
export function useWrite() {
  const repo = useRepo()
  const toast = useToast()
  const [busy, setBusy] = useState(false)
  const write = async (ops: () => Parameters<typeof repo.commit>[0]): Promise<boolean> => {
    setBusy(true)
    try {
      await repo.commit(ops())
      return true
    } catch (error) {
      toast.error(errorMessage(error))
      return false
    } finally {
      setBusy(false)
    }
  }
  return { write, busy }
}

/** A build context for core's builders: this tenant, now. */
export function useBuildContext() {
  const { current } = useWorkspace()
  return () => ({ tenantId: current!.tenant_id, now: new Date().toISOString() })
}
